import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const INFLUENCERS_URI_PREFIX = checkIsStoryBookPath('influencers');
export const ENTITIES_URI_PREFIX = checkIsStoryBookPath('entities');
const TRENDS_PREFIX = 'trends';
const SETTING_PREFIX = 'settings';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const influencerApiRoutes = () => {
  const moduleName = window.location.pathname.split('/')?.[1];
  const isTrendModule = moduleName === 'trends';
  const GENERATE_URI = (PREFIX) =>
    isTrendModule ? `${TRENDS_PREFIX}/${PREFIX}` : PREFIX;

  return {
    storeInfluencerSentiment: `${INFLUENCERS_URI_PREFIX}/details/words/add`,
    changeTweetType: `${INFLUENCERS_URI_PREFIX}/details/twitter/change-tweet-category`,
    changeNewsType: `${INFLUENCERS_URI_PREFIX}/authors/articles/change-category`,
    articlesNewsTab: `${INFLUENCERS_URI_PREFIX}/authors/client/articles`,
    changeVideoType: `${INFLUENCERS_URI_PREFIX}/details/youtube/client-video/change-videos-category`,
    influencerDetails: `${INFLUENCERS_URI_PREFIX}/details/show`,
    addNewInfluencer: `${INFLUENCERS_URI_PREFIX}/details/store`,
    editInfluencer: `${INFLUENCERS_URI_PREFIX}/details/update`,
    deleteInfluencer: `${INFLUENCERS_URI_PREFIX}/details/delete`,
    relatedChannels: `${INFLUENCERS_URI_PREFIX}/details/youtube/channels-analyzed-profiles`,
    allAgeGroup: `${INFLUENCERS_URI_PREFIX}/age-groups/all`,
    resyncInfluencer: `${INFLUENCERS_URI_PREFIX}/details/resync`,
    restoreInfluencer: `${INFLUENCERS_URI_PREFIX}/details/restore`,
    trashInfluencer: `${INFLUENCERS_URI_PREFIX}/details/trash`,
    religions: `${INFLUENCERS_URI_PREFIX}/details/religions/all`,
    importantInfluencer: `${INFLUENCERS_URI_PREFIX}/details/mark-important`,
    unimportantInfluencer: `${INFLUENCERS_URI_PREFIX}/details/mark-unimportant`,
    storeInfluencerName: `${INFLUENCERS_URI_PREFIX}/details/twitter/influencer/unanalyzed/store`,
    storeInfluencerInstagram: `${INFLUENCERS_URI_PREFIX}/details/instagram/influencer/unanalyzed/store`,
    storeInfluencerYoutuber: `${INFLUENCERS_URI_PREFIX}/details/youtube/influencer/unanalyzed/store`,
    getNationalityStauses: `${INFLUENCERS_URI_PREFIX}/details/nationality-status`,
    getNationalityStauses: `${INFLUENCERS_URI_PREFIX}/details/nationality-status`,
    regrabAllOldTweet: `${INFLUENCERS_URI_PREFIX}/details/tweets/all/grab`,
    mostFrequentWords: `${INFLUENCERS_URI_PREFIX}/details/frequent-words`,
    mostFrequentHashtags: `${INFLUENCERS_URI_PREFIX}/details/frequent-hashtags`,
    influencerColumnSentiment: `${INFLUENCERS_URI_PREFIX}/details/sentiment-analysis/data`,
    influencerLocationHistory: `${INFLUENCERS_URI_PREFIX}/details/history/locations`,
    mostFrequentHashtagsAutocomplete: `${INFLUENCERS_URI_PREFIX}/details/hashtags`,
    setsAutocomplete: `${INFLUENCERS_URI_PREFIX}/details/sets`,
    updateSentimentAnalysis: `${INFLUENCERS_URI_PREFIX}/details/sentiment-analysis/data/update`,
    suspendTwitter: `${INFLUENCERS_URI_PREFIX}/details/twitter/twitter-profile/suspend`,
    activateTwitter: `${INFLUENCERS_URI_PREFIX}/details/twitter/twitter-profile/activate`,
    employmentTypes: `${SETTING_PREFIX}/employments/types`,
    regrabDetails: `${INFLUENCERS_URI_PREFIX}/details/force/resync`,
    tweetTypes: `${INFLUENCERS_URI_PREFIX}/details/twitter/tweet/types`,

    //Influencers Table
    trashedGroupsAutoComplete: `${INFLUENCERS_URI_PREFIX}/groups/trashed`,
    influencers: `${INFLUENCERS_URI_PREFIX}/details/all`,
    trashedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/trashed`,
    topInfluencersTab: `${INFLUENCERS_URI_PREFIX}/details/top-influencers`,
    unAnalyzedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/unanalyzed`,
    analyzedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/analyzed`,
    incompleteInfluencers: `${INFLUENCERS_URI_PREFIX}/details/incomplete`,
    allInfluencers: `${INFLUENCERS_URI_PREFIX}/details/all`,
    trendingInfluencers: `${INFLUENCERS_URI_PREFIX}/details/trending`,
    influncersPlatforms: `${INFLUENCERS_URI_PREFIX}/details/platforms`,
    influncersPlatformsStatuses: `${INFLUENCERS_URI_PREFIX}/details/platforms/statuses`,

    // influencer action
    activeGroups: `${INFLUENCERS_URI_PREFIX}/groups/all-active`,
    trashedGroups: `${INFLUENCERS_URI_PREFIX}/groups/all-trashed`,
    activeCategories: `${INFLUENCERS_URI_PREFIX}/categories/all-active`,
    trashedCategories: `${INFLUENCERS_URI_PREFIX}/categories/all-trashed`,

    //categories APIS
    deleteCategory: `/${INFLUENCERS_URI_PREFIX}/categories/delete`,
    trashCategory: `/${INFLUENCERS_URI_PREFIX}/categories/trash`,
    restoreCategory: `/${INFLUENCERS_URI_PREFIX}/categories/restore`,
    getCategoryData: `${INFLUENCERS_URI_PREFIX}/categories/show`,
    addNewCategory: `${INFLUENCERS_URI_PREFIX}/categories/store`,
    editCategory: `${INFLUENCERS_URI_PREFIX}/categories/update`,

    //Groups apis
    addNewGroup: `${INFLUENCERS_URI_PREFIX}/groups/store`,
    trashGroup: `${INFLUENCERS_URI_PREFIX}/groups/trash`,
    restoreGroup: `${INFLUENCERS_URI_PREFIX}/groups/restore`,
    deleteGroup: `${INFLUENCERS_URI_PREFIX}/groups/delete`,
    editGroup: `${INFLUENCERS_URI_PREFIX}/groups/update`,
    getGroupData: `${INFLUENCERS_URI_PREFIX}/groups/show`,
    groupsInfluencersTab: `${INFLUENCERS_URI_PREFIX}/groups/influencers`,

    addNewGroup: `${INFLUENCERS_URI_PREFIX}/groups/store`,
    getGroupData: `${INFLUENCERS_URI_PREFIX}/groups/show`,
    groupTags: `${INFLUENCERS_URI_PREFIX}/groups/tags`,

    getAllAnalyzedInfluencers: `${INFLUENCERS_URI_PREFIX}/analyzed`,

    getAllNewInfluencers: `${INFLUENCERS_URI_PREFIX}/details/new`,
    trendingInfluencersAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/trending`,
    topInfluencersAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/influencers`,
    groupPostsAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/linkedin/posts`,
    groupInstaPostsAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/instagram/posts`,
    NotAuthorsInfluencersAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/analyzed/not-authors`,
    AssignAuthor: `${INFLUENCERS_URI_PREFIX}/details/authors/update`,
    tweetHashtags: `${INFLUENCERS_URI_PREFIX}/groups/tweet/hashtags`,
    videosHashtags: `${INFLUENCERS_URI_PREFIX}/groups/video/hashtags`,
    instagramPostHashtags: `${INFLUENCERS_URI_PREFIX}/details/instagram/post/hashtags`,
    linkedPostHashtags: `${INFLUENCERS_URI_PREFIX}/details/linkedin/post/hashtags`,
    newsTags: `${INFLUENCERS_URI_PREFIX}/groups/news/tags`,
    groupHashtagsAutocomplete: `${INFLUENCERS_URI_PREFIX}/groups/hashtags`,

    // influencer table
    analyzedAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/analyzed`,
    unanalyzedAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/unanalyzed`,
    trashedAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/trashed`,

    mergeInfluencer: `${INFLUENCERS_URI_PREFIX}/details/merge`,
    influencersAutoComplete: `${INFLUENCERS_URI_PREFIX}/details`,
    categoryAutoComplete: `${INFLUENCERS_URI_PREFIX}/categories/activated`,
    trashedCategoryAutoComplete: `${INFLUENCERS_URI_PREFIX}/categories/trashed`,
    categoryOptions: `${INFLUENCERS_URI_PREFIX}/categories/activated/auto-complete`,
    categoriesAutoComplete: `${INFLUENCERS_URI_PREFIX}/categories/activated`,
    groupsAutoComplete: `${INFLUENCERS_URI_PREFIX}/groups/activated`,
    alumniAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/linkedin/alumni`,
    studentsAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/linkedin/students`,
    analyzeInfluencer: `${INFLUENCERS_URI_PREFIX}/details/analyze`,
    getCategories: `${INFLUENCERS_URI_PREFIX}/categories/all-categories`,
    createdCategories: `${INFLUENCERS_URI_PREFIX}/categories/created-categories`,
    getParentCategories: `${INFLUENCERS_URI_PREFIX}/categories/parent-categories`,
    addToParentCategory: `${INFLUENCERS_URI_PREFIX}/categories/attach`,

    getSubCategoryChart: `${INFLUENCERS_URI_PREFIX}/categories/subcategory-chart`,
    educationDegree: `${SETTING_PREFIX}/educations/degrees`,
    conversations: `${INFLUENCERS_URI_PREFIX}/details/twitter/mentions/tweets`,

    //linkedin influencer tab
    linkedAnalyzedTab: `${INFLUENCERS_URI_PREFIX}/details/linkedin/analyze-tab`,
    linkedAnalyzedFollowers: `${INFLUENCERS_URI_PREFIX}/details/linkedin/analyze-tab/followers`,
    linkedAnalyzedRecentPost: `${INFLUENCERS_URI_PREFIX}/details/linkedin/posts/recent`,
    linkedAnalyzedTopWords: `${INFLUENCERS_URI_PREFIX}/details/linkedin/frequent-words`,
    linkedAnalyzedPostClassifications: `${INFLUENCERS_URI_PREFIX}/details/linkedin/posts/classifications`,
    linkedAnalyzedPostLanguage: `${INFLUENCERS_URI_PREFIX}/details/linkedin/posts/languages`,
    linkedAnalyzedPostSentiment: `${INFLUENCERS_URI_PREFIX}/details/linkedin/sentiment-analysis`,
    linkedAnalyzedTopPeople: `${INFLUENCERS_URI_PREFIX}/details/linkedin/top/people`,
    linkedAnalyzedPostsBaseLine: `${INFLUENCERS_URI_PREFIX}/details/linkedin/analyze-tab/base-line/posts`,
    linkedAnalyzedFainedFollowers: `${INFLUENCERS_URI_PREFIX}/details/linkedin/analyze-tab/base-line/followers`,
    linkedAnalyzedCalender: `${INFLUENCERS_URI_PREFIX}/details/linkedin/calender`,
    linkedPostsMentions: `${INFLUENCERS_URI_PREFIX}/details/linkedin/mentions`,
    linkedinPostsTabByMonth: `${INFLUENCERS_URI_PREFIX}/details/linkedin/bymonth-tab`,
    storeInfluencerAsLinkedIn: `${INFLUENCERS_URI_PREFIX}/details/linkedin/influencer/unanalyzed/store`,
    LinkedInPostsTabUpToDate: `${INFLUENCERS_URI_PREFIX}/details/linkedin/posts-tab`,
    LinkedClassifications: `${INFLUENCERS_URI_PREFIX}/details/linkedin/post/classifications`,
    LinkedPostsSorting: `${INFLUENCERS_URI_PREFIX}/details/linkedin/post/sorting`,
    changePostCategory: `${INFLUENCERS_URI_PREFIX}/details/linkedin/change-post-category`,
    allEducations: `${INFLUENCERS_URI_PREFIX}/details/educations`,
    workExperiences: `${INFLUENCERS_URI_PREFIX}/details/works`,
    educationsAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/educations/organization`,
    workAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/works/organization`,
    linkedinHashtags: `${INFLUENCERS_URI_PREFIX}/details/linkedin/hashtags-tab`,
    linkedinHashtagsAutocomplete: `${INFLUENCERS_URI_PREFIX}/details/linkedin/hashtags`,

    //news influncer tab

    newsTabByMonth: `${INFLUENCERS_URI_PREFIX}/authors/bymonth-tab`,
    newsTabAuthorDates: `${INFLUENCERS_URI_PREFIX}/authors/calendar`,
    newsTabAuthorTopWords: `${INFLUENCERS_URI_PREFIX}/authors/frequent-words`,

    // twitter influencer tab

    twitterTweetsPopularity: `${INFLUENCERS_URI_PREFIX}/details/twitter/popular-tab`,
    YoutubePopularity: `${INFLUENCERS_URI_PREFIX}/details/youtube/popular-videos  `,
    twitterAnalyzedTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab`,
    twitterAnalyzedFollower: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab-followers`,
    twitterAnalyzedFollowing: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab-following`,
    twitterAnalyzedTweets: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab-tweets-count`,
    twitterAnalyzedTweetsTypesChart: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/tweets-types`,
    twitterAnalyzedTweetsClassificationChart: `${INFLUENCERS_URI_PREFIX}/details/twitter/tweets/classification`,
    twitterAnalyzedTweetsCloseFriends: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/best-friends`,
    twitterAnalyzeMedia: `${INFLUENCERS_URI_PREFIX}/details/twitter/recent-media`,
    twitterAnalyzedTweetsFollowersBaseLine: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/base-line/followers`,
    twitterAnalyzedTweetsLikesBaseLine: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/base-line/likes`,
    twitterAnalyzedTweetsTweetsBaseLine: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/base-line/tweets`,
    twitterAnalyzedTopPeopleConversation: `${INFLUENCERS_URI_PREFIX}/details/twitter/top-people`,
    twitterAnalyzedFrequentHashtags: `${INFLUENCERS_URI_PREFIX}/details/twitter/frequent-hashtags`,
    twitterAnalyzedRelatedInf: `${INFLUENCERS_URI_PREFIX}/details/related/influencers`,
    twitterAnalyzedRelatedChannels: `${INFLUENCERS_URI_PREFIX}/details/related/entities`,
    twitterAnalyzedTweetClients: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/tweet-sources`,
    twitterAnalyzedTweetClientsPerHours: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/tweet-sources-per-hour`,
    twitterAnalyzedTweetTweetsByLanguage: `${INFLUENCERS_URI_PREFIX}/details/twitter/analyze-tab/tweets/languages`,
    twitterAnalyzedTweetSentiment: `${INFLUENCERS_URI_PREFIX}/details/twitter/sentiment-analysis`,
    twitterAnalyzedTweetLocation: `${INFLUENCERS_URI_PREFIX}/details/twitter/tweets/locations`,
    twitterAnalyzedTweetTopWords: `${INFLUENCERS_URI_PREFIX}/details/twitter/twitter-profile/frequent-words`,
    twitterAnalyzedTweetHashtagAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/twitter/twitter-profile/hashtags`,

    twitterFollowingTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/following-tab`,
    twitterFollowersTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/followers-tab`,
    twitterTweetsTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/tweets-tab`,
    twitterTweetsTabByMonth: `${INFLUENCERS_URI_PREFIX}/details/twitter/bymonth-tab`,
    twitterHashtagTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/hashtags-tab`,
    twitterUsersTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/users-tab`,
    twitterImageTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/image-tab`,
    twitterMentionsTab: `${INFLUENCERS_URI_PREFIX}/details/twitter/mentions`,
    createdGroupsIcon: `${INFLUENCERS_URI_PREFIX}/groups/created-groups`,
    twitterRegrabFollowing: `${INFLUENCERS_URI_PREFIX}/details/twitter/following/re_grab`,
    twitterRegrabFollowers: `${INFLUENCERS_URI_PREFIX}/details/twitter/followers/re_grab`,
    //tiktok influencer tab
    tiktokAnalyzedTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/analyze-tab`,
    storeInfluencerTiktok: `${INFLUENCERS_URI_PREFIX}/details/tiktok/influencer/unanalyzed/store`,
    tiktokFollowersCount: `${INFLUENCERS_URI_PREFIX}/details/tiktok/analyze-tab/followers/count`,
    tiktokFollowingCount: `${INFLUENCERS_URI_PREFIX}/details/tiktok/analyze-tab/following/count`,
    tiktokSentiment: `${INFLUENCERS_URI_PREFIX}/details/tiktok/sentiment-analysis`,
    tiktokLanguage: `${INFLUENCERS_URI_PREFIX}/details/tiktok/posts/languages`,
    tiktokTopWords: `${INFLUENCERS_URI_PREFIX}/details/tiktok/frequent-words`,
    tiktokTopHashtags: `${INFLUENCERS_URI_PREFIX}/details/tiktok/frequent-hashtags`,
    tiktokTopMentions: `${INFLUENCERS_URI_PREFIX}/details/tiktok/mentioned/profiles`,
    tiktokFollowersTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/followers`,
    tiktokRegrabFollowersTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/followers/re_grab`,
    tiktokFollowingTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/following`,
    tiktokRegrabFollowingTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/following/re_grab`,
    tiktokVideosByMonthTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/bymonth-tab`,
    tiktokVideosHashtagsTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/hashtags-tab`,
    tiktokVideosMentionsTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/mentioned/profiles`,
    tiktokActivateProfile: `${INFLUENCERS_URI_PREFIX}/details/tiktok/profile/activate`,
    tiktokSuspendProfile: `${INFLUENCERS_URI_PREFIX}/details/tiktok/profile/suspend`,
    tiktokVideosGroup: `${INFLUENCERS_URI_PREFIX}/groups/tiktok/posts`,
    tiktokVideosGroupAutocomplete: `${INFLUENCERS_URI_PREFIX}/details/tiktok/posts`,
    tiktokPostsTab: `${INFLUENCERS_URI_PREFIX}/details/tiktok/posts-tab`,
    tiktokChangeVideoType: `${INFLUENCERS_URI_PREFIX}/details/tiktok/change-post-category`,
    tiktokHashtagsAutocomplete: `${INFLUENCERS_URI_PREFIX}/details/tiktok/hashtags`,
    tiktokSorting: `${INFLUENCERS_URI_PREFIX}/details/tiktok/posts/sorting`,
    tiktokTopVideos: `${INFLUENCERS_URI_PREFIX}/details/tiktok/analyze-tab/top-posts`,

    // instagram influencer tab
    instagramAnalyzedTab: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab`,
    instagramAnalyzedFollowing: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab/following/count`,
    instagramAnalyzedFollowers: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab/followers/count`,
    instagramAnalyzedPostsTypes: `${INFLUENCERS_URI_PREFIX}/details/instagram/posts/classifications`,
    instagramAnalyzedPosts: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab/posts/count`,
    instagramAnalyzedPostSentiment: `${INFLUENCERS_URI_PREFIX}/details/instagram/sentiment-analysis`,
    instagramAnalyzedTags: `${INFLUENCERS_URI_PREFIX}/details/instagram/frequent-hashtags`,
    instagramAnalyzeTopWords: `${INFLUENCERS_URI_PREFIX}/details/instagram/frequent-words`,
    instagramAnalyzedLikes: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab/likes/count`,
    instagramAnalyzedComments: `${INFLUENCERS_URI_PREFIX}/details/instagram/analyze-tab/comments/count`,
    instagramAnalyzeSimilarAccounts: `${INFLUENCERS_URI_PREFIX}/details/instagram/related/profiles`,
    instagramPostsTab: `${INFLUENCERS_URI_PREFIX}/details/instagram/posts-tab`,
    instagramClassifications: `${INFLUENCERS_URI_PREFIX}/details/instagram/post/classification`,
    instagramPostSorting: `${INFLUENCERS_URI_PREFIX}/details/instagram/post/sorting`,
    instagramMediaTypes: `${INFLUENCERS_URI_PREFIX}/details/instagram/post/media/types`,
    instagramTags: `${INFLUENCERS_URI_PREFIX}/details/instagram/tagged/profiles`,
    instagramMentions: `${INFLUENCERS_URI_PREFIX}/details/instagram/mentioned/profiles`,
    instagramHashtagTab: `${INFLUENCERS_URI_PREFIX}/details/instagram/hashtags-tab`,
    instagramPoststHashtagAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/instagram/hashtags`,
    instagramPostsTabByMonth: `${INFLUENCERS_URI_PREFIX}/details/instagram/bymonth-tab`,
    changeInstagramPostType: `${INFLUENCERS_URI_PREFIX}/details/instagram/change-post-category`,
    instagramAnalyzeMedia: `${INFLUENCERS_URI_PREFIX}/details/instagram/recent-media`,
    instagramLastPost: `${INFLUENCERS_URI_PREFIX}/details/instagram/last-post`,
    instagramProfileSuspend: `${INFLUENCERS_URI_PREFIX}/details/instagram/profile/suspend`,
    instagramProfileActive: `${INFLUENCERS_URI_PREFIX}/details/instagram/profile/activate`,
    instagramFollowers: `${INFLUENCERS_URI_PREFIX}/details/instagram/followers`,
    instagramFollowing: `${INFLUENCERS_URI_PREFIX}/details/instagram/following`,
    instagramRegrabFollowers: `${INFLUENCERS_URI_PREFIX}/details/instagram/followers/re_grab`,
    instagramRegrabFollowing: `${INFLUENCERS_URI_PREFIX}/details/instagram/following/re_grab`,
    // items-to-group apis
    groupsTweeterTab: `${INFLUENCERS_URI_PREFIX}/groups/tweets`,
    groupsVideosTab: `${INFLUENCERS_URI_PREFIX}/groups/videos`,
    groupsArticlesTab: `${INFLUENCERS_URI_PREFIX}/groups/news`,
    groupsPostsTab: `${INFLUENCERS_URI_PREFIX}/groups/linkedin/posts`,
    groupInstagramTab: `${INFLUENCERS_URI_PREFIX}/groups/instagram/posts`,
    // analyzed influencer details
    analyzedInfluencerDetails: `${INFLUENCERS_URI_PREFIX}/details/show`,
    youtubeAnalyzeTab: `${INFLUENCERS_URI_PREFIX}/details/youtube/analyze-tab`,
    youtubeVideosTab: `${INFLUENCERS_URI_PREFIX}/details/youtube/client-videos/all`,
    youtubeAnalyzeTabSubscribers: `${INFLUENCERS_URI_PREFIX}/details/youtube/analyze-tab-subscribers`,
    youtubeAnalyzeTabUploadedVideos: `${INFLUENCERS_URI_PREFIX}/details/youtube/analyze-tab-uploaded-videos`,
    youtubeAnalyzeTabTotalViews: `${INFLUENCERS_URI_PREFIX}/details/youtube/analyze-tab-videos-views`,
    youtubeAnalyzeTabVideosChart: `${INFLUENCERS_URI_PREFIX}/details/youtube/uploaded-videos-count-chart`,
    youtubeAnalyzeTabSubscribersChart: `${INFLUENCERS_URI_PREFIX}/details/youtube/subscribers-count-chart`,
    youtubeAnalyzeTabViewsChart: `${INFLUENCERS_URI_PREFIX}/details/youtube/views-count-chart`,
    youtubeAnalyzeTabFutureSubscribersChart: `${INFLUENCERS_URI_PREFIX}/details/youtube/future-subscribers-count-chart`,
    youtubeAnalyzeTabFutureViewsChart: `${INFLUENCERS_URI_PREFIX}/details/youtube/future-views-count-chart`,
    youtubeVideosTabHashtags: `${INFLUENCERS_URI_PREFIX}/details/youtube/related-hashtags`,
    youtubeVideosTabByMonth: `${INFLUENCERS_URI_PREFIX}/details/youtube/videos-views-per-year-month`,
    youtubeVideosTabFeaturing: `${INFLUENCERS_URI_PREFIX}/details/youtube/channels-featuring`,
    youtubeVideosTabFeaturingBy: `${INFLUENCERS_URI_PREFIX}/details/youtube/channels-featured-by`,
    youtubeVideosTabRelatedHastags: `${INFLUENCERS_URI_PREFIX}/details/youtube/related-hashtags`,
    youtubeVideosTabRelatedTags: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/tags`,
    youtubeAnalyzedVideoHashtagAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/hashtags`,

    //auto-complete
    //youtubeVideosTabSimilarChannels
    //activityapi
    youtubeAchievementsTabInprogress: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel-achievements/in-progress`,
    youtubeTabTopWords: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/frequent-words`,
    youtubeTabTopTags: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/tags`,
    youtubeAchievementsTabCompleted: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel-achievements/completed`,
    youtubeTodayTweets: `${INFLUENCERS_URI_PREFIX}/details/youtube/client-videos/all`,
    youtubeCalendar: `${INFLUENCERS_URI_PREFIX}/details/youtube/calendar`,
    youtubeRelatedChannel: `${INFLUENCERS_URI_PREFIX}/details/youtube/related/channels`,
    youtubeAnalyzedTweetSentiment: `${INFLUENCERS_URI_PREFIX}/details/youtube/sentiment-analysis`,
    youtubeAnalyzedFrequentHashtags: `${INFLUENCERS_URI_PREFIX}/details/youtube/related-hashtags`,

    authorAnalyzedTweetSentiment: `${INFLUENCERS_URI_PREFIX}/authors/sentiment-analysis`,

    //dashboard apis
    totalInfluencersCount: `${INFLUENCERS_URI_PREFIX}/details/total-influencers-count`,
    analyzedIfluencersCount: `${INFLUENCERS_URI_PREFIX}/details/analyzed-influencers-count`,
    unAnalyzedIfluencersCount: `${INFLUENCERS_URI_PREFIX}/details/unanalyzed-influencers-count`,
    totalIfluencersTweets: `${INFLUENCERS_URI_PREFIX}/details/total-tweets`,
    totalIfluencersGroups: `${INFLUENCERS_URI_PREFIX}/groups/total-groups`,
    totalIfluencersCategories: `${INFLUENCERS_URI_PREFIX}/categories/total-categories`,
    topFiveTrendingInfluencers: `${INFLUENCERS_URI_PREFIX}/details/bar-latest-five-influencer`,
    influencersGroup: `${INFLUENCERS_URI_PREFIX}/groups/per-group-chart`,
    influencersCategory: `${INFLUENCERS_URI_PREFIX}/categories/inf-category-chart`,
    influencersPlatform: `${INFLUENCERS_URI_PREFIX}/details/platform`,
    influencersAgeGroup: `${INFLUENCERS_URI_PREFIX}/details/age-group`,
    influencersGender: `${INFLUENCERS_URI_PREFIX}/details/gender`,
    topInfluencers: `${INFLUENCERS_URI_PREFIX}/details/dashboard-top-influencers`,
    influencersMap: GENERATE_URI(`${INFLUENCERS_URI_PREFIX}/details/map`),
    dashboardCatSubCat: `${INFLUENCERS_URI_PREFIX}/categories/inf-count-per-subcategory`,
    loadCalendarData: `${INFLUENCERS_URI_PREFIX}/details/youtube/month-calender`,
    influencerGrabbingStatus: `${INFLUENCERS_URI_PREFIX}/details/grabbing-status`,
    InfluncerAuthorArticleCount: `${INFLUENCERS_URI_PREFIX}/authors/articles/count`,
    InfluncerAuthorSourcesCount: `${INFLUENCERS_URI_PREFIX}/authors/sources/count`,
    InfluncerAuthorArticleAverage: `${INFLUENCERS_URI_PREFIX}/authors/average-articles`,
    InfluncerAuthorArticleChart: `${INFLUENCERS_URI_PREFIX}/authors/article-chart`,
    InfluncerAuthorSources: `${INFLUENCERS_URI_PREFIX}/authors/sources`,
    InfluncerAuthorTags: `${INFLUENCERS_URI_PREFIX}/authors/tags`,
    InfluncerAuthorCalander: `${INFLUENCERS_URI_PREFIX}/authors/calendar`,
    twitterTweetClients: `${INFLUENCERS_URI_PREFIX}/details/twitter/chart/base-line/tweet-sources`,
    influencerUploadedVideos: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/chart/uploaded-videos`,
    channelSubscribers: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/chart/gained-subscribers`,
    channelViews: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/chart/views`,
    channelActivities: `${INFLUENCERS_URI_PREFIX}/details/youtube/channel/chart/activities`,
    logs: `${INFLUENCERS_URI_PREFIX}/details`,
    convertInfluencer: `${INFLUENCERS_URI_PREFIX}/details/convert`,
    infInfoOptions: `${INFLUENCERS_URI_PREFIX}/information/sections`,
    influencerRelationOptions: `${INFLUENCERS_URI_PREFIX}/details/relations`,
    //related influencer
    allRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/`,
    coworkersRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/coworkers`,
    fellowStudentsInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/fellow-students`,
    fellowStudentsAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/fellow-students`,
    relativesRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/relatives`,
    friendsRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/friends`,
    mentionsRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/mentions`,
    mapGraph: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/map`,
    mapGraphTree: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/map/tree`,

    //related entity
    allRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/`,
    coworkersRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/coworkers`,
    schoolUniversityRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/study-places`,
    relativesRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/relatives`,
    friendsRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/friends`,
    mentionsRelatedEntities: `${INFLUENCERS_URI_PREFIX}/details/related-entities/mentions`,
    schoolUniversityAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/related-entities/study-places`,
    //unlink
    unlinkRelativesRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/relatives/un-link`,
    unlinkFriendsRelatedInfluencers: `${INFLUENCERS_URI_PREFIX}/details/related-influencers/friends/un-link`,
    organizationAutoComplete: `${INFLUENCERS_URI_PREFIX}/details/organization`,
    regrabGroup: `${INFLUENCERS_URI_PREFIX}/groups/regrab`,
    getReportInfCount: `${INFLUENCERS_URI_PREFIX}/details/detailed-reports/count`,
    degreeAutoComplete: `${SETTING_PREFIX}/educations/degrees`,
  };
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const entitiesApiRoutes = () => {
  const moduleName = window.location.pathname.split('/')?.[1];
  const isTrendModule = moduleName === 'trends';
  const GENERATE_URI = (PREFIX) =>
    isTrendModule ? `${TRENDS_PREFIX}/${PREFIX}` : PREFIX;
  return {
    storeInfluencerSentiment: `${ENTITIES_URI_PREFIX}/details/words/add`,
    changeTweetType: `${ENTITIES_URI_PREFIX}/details/twitter/change-tweet-category`,
    changeNewsType: `${ENTITIES_URI_PREFIX}/authors/articles/change-category`,
    changeVideoType: `${ENTITIES_URI_PREFIX}/details/youtube/client-video/change-videos-category`,
    articlesNewsTab: `${ENTITIES_URI_PREFIX}/authors/client/articles`,
    youtubeVideosTabRelatedHastags: `${ENTITIES_URI_PREFIX}/details/youtube/related-hashtags`,
    youtubeVideosTabRelatedTags: `${ENTITIES_URI_PREFIX}/details/youtube/channel/tags`,
    youtubeAnalyzedVideoHashtagAutoComplete: `${ENTITIES_URI_PREFIX}/details/youtube/channel/hashtags`,

    influencerDetails: `${ENTITIES_URI_PREFIX}/details/show`,
    addNewInfluencer: `${ENTITIES_URI_PREFIX}/details/store`,
    editInfluencer: `${ENTITIES_URI_PREFIX}/details/update`,
    deleteInfluencer: `${ENTITIES_URI_PREFIX}/details/delete`,
    relatedChannels: `${ENTITIES_URI_PREFIX}/details/youtube/channels-analyzed-profiles`,
    allAgeGroup: `${ENTITIES_URI_PREFIX}/age-groups/all`,
    resyncInfluencer: `${ENTITIES_URI_PREFIX}/details/resync`,
    restoreInfluencer: `${ENTITIES_URI_PREFIX}/details/restore`,
    trashInfluencer: `${ENTITIES_URI_PREFIX}/details/trash`,
    industries: `${ENTITIES_URI_PREFIX}/industries/all`,
    importantInfluencer: `${ENTITIES_URI_PREFIX}/details/mark-important`,
    unimportantInfluencer: `${ENTITIES_URI_PREFIX}/details/mark-unimportant`,
    regrabAllOldTweet: `${ENTITIES_URI_PREFIX}/details/tweets/all/grab`,
    mostFrequentWords: `${ENTITIES_URI_PREFIX}/details/frequent-words`,
    mostFrequentHashtags: `${ENTITIES_URI_PREFIX}/details/frequent-hashtags`,
    influencerColumnSentiment: `${ENTITIES_URI_PREFIX}/details/sentiment-analysis/data`,
    mostFrequentHashtagsAutocomplete: `${ENTITIES_URI_PREFIX}/details/hashtags`,
    setsAutocomplete: `${ENTITIES_URI_PREFIX}/details/sets`,

    updateSentimentAnalysis: `${ENTITIES_URI_PREFIX}/details/sentiment-analysis/data/update`,

    //Influencers Table
    trashedGroupsAutoComplete: `${ENTITIES_URI_PREFIX}/groups/trashed`,
    influencers: `${ENTITIES_URI_PREFIX}/details/all`,
    trashedInfluencers: `${ENTITIES_URI_PREFIX}/details/trashed`,
    topInfluencersTab: `${ENTITIES_URI_PREFIX}/details/top-influencers`,
    unAnalyzedInfluencers: `${ENTITIES_URI_PREFIX}/details/unanalyzed`,
    analyzedInfluencers: `${ENTITIES_URI_PREFIX}/details/analyzed`,
    incompleteInfluencers: `${ENTITIES_URI_PREFIX}/details/incomplete`,
    allInfluencers: `${ENTITIES_URI_PREFIX}/details/all`,
    trendingInfluencers: `${ENTITIES_URI_PREFIX}/details/trending`,

    // influencer action
    activeGroups: `${ENTITIES_URI_PREFIX}/groups/all-active`,
    trashedGroups: `${ENTITIES_URI_PREFIX}/groups/all-trashed`,
    activeCategories: `${ENTITIES_URI_PREFIX}/categories/all-active`,
    trashedCategories: `${ENTITIES_URI_PREFIX}/categories/all-trashed`,
    //  trendingInfluencers: `${ENTITIES_URI_PREFIX}/details/analyzed`,
    //categories APIS
    deleteCategory: `/${ENTITIES_URI_PREFIX}/categories/delete`,
    trashCategory: `/${ENTITIES_URI_PREFIX}/categories/trash`,
    restoreCategory: `/${ENTITIES_URI_PREFIX}/categories/restore`,
    getCategoryData: `${ENTITIES_URI_PREFIX}/categories/show`,
    addNewCategory: `${ENTITIES_URI_PREFIX}/categories/store`,
    editCategory: `${ENTITIES_URI_PREFIX}/categories/update`,

    //Groups apis
    addNewGroup: `${ENTITIES_URI_PREFIX}/groups/store`,
    editGroup: `${ENTITIES_URI_PREFIX}/groups/update`,

    trashGroup: `${ENTITIES_URI_PREFIX}/groups/trash`,
    restoreGroup: `${ENTITIES_URI_PREFIX}/groups/restore`,
    deleteGroup: `${ENTITIES_URI_PREFIX}/groups/delete`,
    getGroupData: `${ENTITIES_URI_PREFIX}/groups/show`,
    groupsInfluencersTab: `${ENTITIES_URI_PREFIX}/groups/influencers`,

    addNewGroup: `${ENTITIES_URI_PREFIX}/groups/store`,
    getGroupData: `${ENTITIES_URI_PREFIX}/groups/show`,

    getAllAnalyzedInfluencers: `${ENTITIES_URI_PREFIX}/analyzed`,
    tweetHashtags: `${ENTITIES_URI_PREFIX}/groups/tweet/hashtags`,
    videosHashtags: `${ENTITIES_URI_PREFIX}/groups/video/hashtags`,
    instagramPostHashtags: `${ENTITIES_URI_PREFIX}/details/instagram/post/hashtags`,
    linkedPostHashtags: `${ENTITIES_URI_PREFIX}/details/linkedin/post/hashtags`,
    newsTags: `${ENTITIES_URI_PREFIX}/groups/news/tags`,
    groupHashtagsAutocomplete: `${ENTITIES_URI_PREFIX}/groups/hashtags`,

    getAllNewInfluencers: `${ENTITIES_URI_PREFIX}/details/new`,
    trendingInfluencersAutoComplete: `${ENTITIES_URI_PREFIX}/details/trending`,
    topInfluencersAutoComplete: `${ENTITIES_URI_PREFIX}/details/influencers`,
    influencerLocationHistory: `${ENTITIES_URI_PREFIX}/details/history/locations`,
    groupPostsAutoComplete: `${ENTITIES_URI_PREFIX}/details/linkedin/posts`,
    groupInstaPostsAutoComplete: `${ENTITIES_URI_PREFIX}/details/instagram/posts`,
    educationDegreeAutoComplete: `${SETTING_PREFIX}/educations/degrees`,
    employeeAutoComplete: `${ENTITIES_URI_PREFIX}/details/linkedin/employees`,
    exEmployeeAutoComplete: `${ENTITIES_URI_PREFIX}/details/linkedin/ex-employees`,
    jobTitleExEmployeesAutoComplete: `${ENTITIES_URI_PREFIX}/details/linkedin/ex-employees/job-title`,
    jobTitleEmployeesAutoComplete: `${ENTITIES_URI_PREFIX}/details/linkedin/employees/job-title`,
    twitterSorting: `${SETTING_PREFIX}/twitter/tweets/sorting`,
    videosSorting: `${SETTING_PREFIX}/youtube/videos/sorting`,
    linkedinSorting: `${SETTING_PREFIX}/linkedin/posts/sorting`,
    instagramSorting: `${SETTING_PREFIX}/instagram/posts/sorting`,

    // influencer table
    analyzedAutoComplete: `${ENTITIES_URI_PREFIX}/details/analyzed`,
    unanalyzedAutoComplete: `${ENTITIES_URI_PREFIX}/details/unanalyzed`,
    trashedAutoComplete: `${ENTITIES_URI_PREFIX}/details/trashed`,

    mergeInfluencer: `${ENTITIES_URI_PREFIX}/details/merge`,
    influencersAutoComplete: `${ENTITIES_URI_PREFIX}/details`,
    categoryAutoComplete: `${ENTITIES_URI_PREFIX}/categories/activated`,
    trashedCategoryAutoComplete: `${ENTITIES_URI_PREFIX}/categories/trashed`,
    categoryOptions: `${ENTITIES_URI_PREFIX}/categories/activated/auto-complete`,
    categoriesAutoComplete: `${ENTITIES_URI_PREFIX}/categories/activated`,
    groupsAutoComplete: `${ENTITIES_URI_PREFIX}/groups/activated`,
    analyzeInfluencer: `${ENTITIES_URI_PREFIX}/details/analyze`,
    getCategories: `${ENTITIES_URI_PREFIX}/categories/all-categories`,
    createdCategories: `${ENTITIES_URI_PREFIX}/categories/created-categories`,
    getParentCategories: `${ENTITIES_URI_PREFIX}/categories/parent-categories`,
    addToParentCategory: `${ENTITIES_URI_PREFIX}/categories/attach`,

    getSubCategoryChart: `${ENTITIES_URI_PREFIX}/categories/subcategory-chart`,

    // twitter influencer tab

    twitterTweetsPopularity: `${ENTITIES_URI_PREFIX}/details/twitter/popular-tab`,
    YoutubePopularity: `${ENTITIES_URI_PREFIX}/details/youtube/popular-videos  `,
    twitterAnalyzedTab: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab`,
    twitterAnalyzedFollower: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab-followers`,
    twitterAnalyzedFollowing: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab-following`,
    twitterAnalyzedTweets: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab-tweets-count`,
    twitterAnalyzedTweetsTypesChart: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/tweets-types`,
    twitterAnalyzedTweetsClassificationChart: `${ENTITIES_URI_PREFIX}/details/twitter/tweets/classification`,
    twitterAnalyzedTweetsCloseFriends: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/best-friends`,
    twitterAnalyzeMedia: `${ENTITIES_URI_PREFIX}/details/twitter/recent-media`,
    twitterAnalyzedTweetsFollowersBaseLine: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/base-line/followers`,
    twitterAnalyzedTweetsLikesBaseLine: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/base-line/likes`,
    twitterAnalyzedTweetsTweetsBaseLine: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/base-line/tweets`,
    twitterAnalyzedTopPeopleConversation: `${ENTITIES_URI_PREFIX}/details/twitter/top-people`,
    twitterAnalyzedFrequentHashtags: `${ENTITIES_URI_PREFIX}/details/twitter/frequent-hashtags`,
    twitterAnalyzedRelatedInf: `${ENTITIES_URI_PREFIX}/details/related/influencers`,
    twitterAnalyzedRelatedChannels: `${ENTITIES_URI_PREFIX}/details/related/entities`,
    twitterAnalyzedTweetClients: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/tweet-sources`,
    twitterAnalyzedTweetClientsPerHours: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/tweet-sources-per-hour`,
    twitterAnalyzedTweetTweetsByLanguage: `${ENTITIES_URI_PREFIX}/details/twitter/analyze-tab/tweets/languages`,
    twitterAnalyzedTweetSentiment: `${ENTITIES_URI_PREFIX}/details/twitter/sentiment-analysis`,
    twitterAnalyzedTweetLocation: `${ENTITIES_URI_PREFIX}/details/twitter/tweets/locations`,
    twitterAnalyzedTweetTopWords: `${ENTITIES_URI_PREFIX}/details/twitter/twitter-profile/frequent-words`,
    twitterAnalyzedTweetHashtagAutoComplete: `${ENTITIES_URI_PREFIX}/details/twitter/twitter-profile/hashtags`,
    suspendTwitter: `${ENTITIES_URI_PREFIX}/details/twitter/twitter-profile/suspend`,
    activateTwitter: `${ENTITIES_URI_PREFIX}/details/twitter/twitter-profile/activate`,
    regrabDetails: `${ENTITIES_URI_PREFIX}/details/force/resync`,
    tweetTypes: `${ENTITIES_URI_PREFIX}/details/twitter/tweet/types`,

    twitterRegrabFollowing: `${ENTITIES_URI_PREFIX}/details/twitter/following/re_grab`,
    twitterRegrabFollowers: `${ENTITIES_URI_PREFIX}/details/twitter/followers/re_grab`,
    twitterTweetClients: `${ENTITIES_URI_PREFIX}/details/twitter/chart/base-line/tweet-sources`,
    twitterFollowingTab: `${ENTITIES_URI_PREFIX}/details/twitter/following-tab`,
    twitterFollowersTab: `${ENTITIES_URI_PREFIX}/details/twitter/followers-tab`,
    twitterTweetsTab: `${ENTITIES_URI_PREFIX}/details/twitter/tweets-tab`,
    twitterTweetsTabByMonth: `${ENTITIES_URI_PREFIX}/details/twitter/bymonth-tab`,
    twitterHashtagTab: `${ENTITIES_URI_PREFIX}/details/twitter/hashtags-tab`,
    twitterUsersTab: `${ENTITIES_URI_PREFIX}/details/twitter/users-tab`,
    twitterImageTab: `${ENTITIES_URI_PREFIX}/details/twitter/image-tab`,
    twitterMentionsTab: `${ENTITIES_URI_PREFIX}/details/twitter/mentions`,
    createdGroupsIcon: `${ENTITIES_URI_PREFIX}/groups/created-groups`,
    entityGrabbingStatus: `${ENTITIES_URI_PREFIX}/details/grabbing-status`,
    entityPlatforms: `${ENTITIES_URI_PREFIX}/details/platforms`,
    entityPlatformsStatuses: `${ENTITIES_URI_PREFIX}/details/platforms/statuses`,
    //tiktok entities tab
    tiktokAnalyzedTab: `${ENTITIES_URI_PREFIX}/details/tiktok/analyze-tab`,
    storeInfluencerTiktok: `${ENTITIES_URI_PREFIX}/details/tiktok/influencer/unanalyzed/store`,
    tiktokFollowersCount: `${ENTITIES_URI_PREFIX}/details/tiktok/analyze-tab/followers/count`,
    tiktokFollowingCount: `${ENTITIES_URI_PREFIX}/details/tiktok/analyze-tab/following/count`,
    tiktokSentiment: `${ENTITIES_URI_PREFIX}/details/tiktok/sentiment-analysis`,
    tiktokLanguage: `${ENTITIES_URI_PREFIX}/details/tiktok/posts/languages`,
    tiktokTopWords: `${ENTITIES_URI_PREFIX}/details/tiktok/frequent-words`,
    tiktokTopHashtags: `${ENTITIES_URI_PREFIX}/details/tiktok/frequent-hashtags`,
    tiktokTopMentions: `${ENTITIES_URI_PREFIX}/details/tiktok/mentioned/profiles`,
    tiktokFollowersTab: `${ENTITIES_URI_PREFIX}/details/tiktok/followers`,
    tiktokRegrabFollowersTab: `${ENTITIES_URI_PREFIX}/details/tiktok/followers/re_grab`,
    tiktokFollowingTab: `${ENTITIES_URI_PREFIX}/details/tiktok/following`,
    tiktokRegrabFollowingTab: `${ENTITIES_URI_PREFIX}/details/tiktok/following/re_grab`,
    tiktokVideosByMonthTab: `${ENTITIES_URI_PREFIX}/details/tiktok/bymonth-tab`,
    tiktokVideosHashtagsTab: `${ENTITIES_URI_PREFIX}/details/tiktok/hashtags-tab`,
    tiktokVideosMentionsTab: `${ENTITIES_URI_PREFIX}/details/tiktok/mentioned/profiles`,
    tiktokActivateProfile: `${ENTITIES_URI_PREFIX}/details/tiktok/profile/activate`,
    tiktokSuspendProfile: `${ENTITIES_URI_PREFIX}/details/tiktok/profile/suspend`,
    tiktokVideosGroup: `${ENTITIES_URI_PREFIX}/groups/tiktok/posts`,
    tiktokPostsTab: `${ENTITIES_URI_PREFIX}/details/tiktok/posts-tab`,
    tiktokChangeVideoType: `${ENTITIES_URI_PREFIX}/details/tiktok/change-post-category`,
    tiktokVideosGroupAutocomplete: `${ENTITIES_URI_PREFIX}/details/tiktok/posts`,
    tiktokHashtagsAutocomplete: `${ENTITIES_URI_PREFIX}/details/tiktok/hashtags`,
    tiktokSorting: `${ENTITIES_URI_PREFIX}/details/tiktok/posts/sorting`,
    tiktokTopVideos: `${INFLUENCERS_URI_PREFIX}/details/tiktok/analyze-tab/top-posts`,

    // tiktokGainedFollowers: `${ENTITIES_URI_PREFIX}/details/tiktok/analyze-tab/following/count`,

    // instagram influencer tab
    instagramAnalyzedTab: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab`,
    instagramAnalyzedFollowing: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab/following/count`,
    instagramAnalyzedFollowers: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab/followers/count`,
    instagramAnalyzedPostsTypes: `${ENTITIES_URI_PREFIX}/details/instagram/posts/classifications`,
    instagramAnalyzedPosts: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab/posts/count`,
    instagramAnalyzedPostSentiment: `${ENTITIES_URI_PREFIX}/details/instagram/sentiment-analysis`,
    instagramAnalyzedTags: `${ENTITIES_URI_PREFIX}/details/instagram/frequent-hashtags`,
    instagramAnalyzeTopWords: `${ENTITIES_URI_PREFIX}/details/instagram/frequent-words`,
    instagramAnalyzedLikes: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab/likes/count`,
    instagramAnalyzedComments: `${ENTITIES_URI_PREFIX}/details/instagram/analyze-tab/comments/count`,
    instagramAnalyzeSimilarAccounts: `${ENTITIES_URI_PREFIX}/details/instagram/related/profiles`,
    instagramPostsTab: `${ENTITIES_URI_PREFIX}/details/instagram/posts-tab`,
    instagramClassifications: `${ENTITIES_URI_PREFIX}/details/instagram/post/classification`,
    instagramPostSorting: `${ENTITIES_URI_PREFIX}/details/instagram/post/sorting`,
    instagramMediaTypes: `${ENTITIES_URI_PREFIX}/details/instagram/post/media/types`,
    instagramTags: `${ENTITIES_URI_PREFIX}/details/instagram/tagged/profiles`,
    instagramMentions: `${ENTITIES_URI_PREFIX}/details/instagram/mentioned/profiles`,
    instagramHashtagTab: `${ENTITIES_URI_PREFIX}/details/instagram/hashtags-tab`,
    instagramPoststHashtagAutoComplete: `${ENTITIES_URI_PREFIX}/details/instagram/hashtags`,
    instagramPostsTabByMonth: `${ENTITIES_URI_PREFIX}/details/instagram/bymonth-tab`,
    changeInstagramPostType: `${ENTITIES_URI_PREFIX}/details/instagram/change-post-category`,
    instagramAnalyzeMedia: `${ENTITIES_URI_PREFIX}/details/instagram/recent-media`,
    instagramLastPost: `${ENTITIES_URI_PREFIX}/details/instagram/last-post`,
    instagramProfileSuspend: `${ENTITIES_URI_PREFIX}/details/instagram/profile/suspend`,
    instagramProfileActive: `${ENTITIES_URI_PREFIX}/details/instagram/profile/activate`,
    instagramFollowers: `${ENTITIES_URI_PREFIX}/details/instagram/followers`,
    instagramFollowing: `${ENTITIES_URI_PREFIX}/details/instagram/following`,
    instagramRegrabFollowers: `${ENTITIES_URI_PREFIX}/details/instagram/followers/re_grab`,
    instagramRegrabFollowing: `${ENTITIES_URI_PREFIX}/details/instagram/following/re_grab`,
    // linked entities tab
    linkedAnalyzedPostClassifications: `${ENTITIES_URI_PREFIX}/details/linkedin/posts/classifications`,
    linkedAnalyzedPostLanguage: `${ENTITIES_URI_PREFIX}/details/linkedin/posts/languages`,
    linkedAnalyzedPostSentiment: `${ENTITIES_URI_PREFIX}/details/linkedin/sentiment-analysis`,
    linkedAnalyzedEmployeeOnLinkedin: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab/employees/count`,
    linkedAnalyzedOpenJob: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab/jobs/count`,
    linkedAnalyzedTab: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab`,
    linkedAnalyzedRecentPost: `${ENTITIES_URI_PREFIX}/details/linkedin/posts/recent`,
    linkedAnalyzedTopWords: `${ENTITIES_URI_PREFIX}/details/linkedin/frequent-words`,
    linkedAnalyzedPostsBaseLine: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab/base-line/posts`,
    linkedAnalyzedFainedFollowers: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab/base-line/followers`,
    LinkedInPostsTabUpToDate: `${ENTITIES_URI_PREFIX}/details/linkedin/posts-tab`,
    changePostCategory: `${ENTITIES_URI_PREFIX}/details/linkedin/change-post-category`,
    allEducations: `${ENTITIES_URI_PREFIX}/details/educations`,
    workExperiences: `${ENTITIES_URI_PREFIX}/details/works`,
    educationsAutoComplete: `${ENTITIES_URI_PREFIX}/details/educations/organization`,
    workAutoComplete: `${ENTITIES_URI_PREFIX}/details/works/organization`,
    linkedinHashtags: `${ENTITIES_URI_PREFIX}/details/linkedin/hashtags-tab`,
    linkedinHashtagsAutocomplete: `${ENTITIES_URI_PREFIX}/details/linkedin/hashtags`,
    linkedinPostsTabByMonth: `${ENTITIES_URI_PREFIX}/details/linkedin/bymonth-tab`,
    linkedAnalyzedFollowers: `${ENTITIES_URI_PREFIX}/details/linkedin/analyze-tab/followers`,
    LinkedClassifications: `${ENTITIES_URI_PREFIX}/details/linkedin/post/classifications`,
    LinkedPostsSorting: `${ENTITIES_URI_PREFIX}/details/linkedin/post/sorting`,
    LinkedJobsTab: `${ENTITIES_URI_PREFIX}/details/linkedin/jobs`,
    LinkedEmployeesTab: `${ENTITIES_URI_PREFIX}/details/linkedin/employees`,
    LinkedEmployeesRegrab: `${ENTITIES_URI_PREFIX}/details/linkedin/employees/re-grab`,
    LinkedExEmployeesTab: `${ENTITIES_URI_PREFIX}/details/linkedin/ex-employees`,
    LinkedAlumniTab: `${ENTITIES_URI_PREFIX}/details/linkedin/alumni`,
    LinkedStudentsTab: `${ENTITIES_URI_PREFIX}/details/linkedin/students`,
    conversations: `${ENTITIES_URI_PREFIX}/details/twitter/mentions/tweets`,

    //news influncer tab

    newsTabByMonth: `${ENTITIES_URI_PREFIX}/authors/bymonth-tab`,
    newsTabAuthorDates: `${ENTITIES_URI_PREFIX}/authors/calendar`,
    newsTabAuthorTopWords: `${ENTITIES_URI_PREFIX}/authors/frequent-words`,

    // items-to-group apis
    groupsTweeterTab: `${ENTITIES_URI_PREFIX}/groups/tweets`,
    groupsVideosTab: `${ENTITIES_URI_PREFIX}/groups/videos`,
    groupsArticlesTab: `${ENTITIES_URI_PREFIX}/groups/news`,
    groupsPostsTab: `${ENTITIES_URI_PREFIX}/groups/linkedin/posts`,
    groupInstagramTab: `${ENTITIES_URI_PREFIX}/groups/instagram/posts`,
    // analyzed influencer details
    analyzedInfluencerDetails: `${ENTITIES_URI_PREFIX}/details/show`,
    youtubeAnalyzeTab: `${ENTITIES_URI_PREFIX}/details/youtube/analyze-tab`,
    youtubeVideosTab: `${ENTITIES_URI_PREFIX}/details/youtube/client-videos/all`,
    youtubeAnalyzeTabSubscribers: `${ENTITIES_URI_PREFIX}/details/youtube/analyze-tab-subscribers`,
    youtubeAnalyzeTabUploadedVideos: `${ENTITIES_URI_PREFIX}/details/youtube/analyze-tab-uploaded-videos`,
    youtubeAnalyzeTabTotalViews: `${ENTITIES_URI_PREFIX}/details/youtube/analyze-tab-videos-views`,
    youtubeAnalyzeTabVideosChart: `${ENTITIES_URI_PREFIX}/details/youtube/uploaded-videos-count-chart`,
    youtubeAnalyzeTabSubscribersChart: `${ENTITIES_URI_PREFIX}/details/youtube/subscribers-count-chart`,
    youtubeAnalyzeTabViewsChart: `${ENTITIES_URI_PREFIX}/details/youtube/views-count-chart`,
    youtubeAnalyzeTabFutureSubscribersChart: `${ENTITIES_URI_PREFIX}/details/youtube/future-subscribers-count-chart`,
    youtubeAnalyzeTabFutureViewsChart: `${ENTITIES_URI_PREFIX}/details/youtube/future-subscribers-count-chart`,
    youtubeVideosTabHashtags: `${ENTITIES_URI_PREFIX}/details/youtube/related-hashtags`,
    youtubeVideosTabByMonth: `${ENTITIES_URI_PREFIX}/details/youtube/videos-views-per-year-month`,
    youtubeVideosTabFeaturing: `${ENTITIES_URI_PREFIX}/details/youtube/channels-featuring`,
    youtubeVideosTabFeaturingBy: `${ENTITIES_URI_PREFIX}/details/youtube/channels-featured-by`,
    youtubeAchievementsTabInprogress: `${ENTITIES_URI_PREFIX}/details/youtube/channel-achievements/in-progress`,
    youtubeAchievementsTabCompleted: `${ENTITIES_URI_PREFIX}/details/youtube/channel-achievements/completed`,
    youtubeTodayTweets: `${ENTITIES_URI_PREFIX}/details/youtube/client-videos/all`,
    youtubeCalendar: `${ENTITIES_URI_PREFIX}/details/youtube/calendar`,
    youtubeRelatedChannel: `${ENTITIES_URI_PREFIX}/details/youtube/related/channels`,
    youtubeAnalyzedTweetSentiment: `${ENTITIES_URI_PREFIX}/details/youtube/sentiment-analysis`,
    youtubeTabTopWords: `${ENTITIES_URI_PREFIX}/details/youtube/channel/frequent-words`,
    youtubeTabTopTags: `${ENTITIES_URI_PREFIX}/details/youtube/channel/tags`,
    youtubeAnalyzedFrequentHashtags: `${ENTITIES_URI_PREFIX}/details/youtube/related-hashtags`,

    authorAnalyzedTweetSentiment: `${ENTITIES_URI_PREFIX}/authors/sentiment-analysis`,

    //dashboard apis
    totalInfluencersCount: `${ENTITIES_URI_PREFIX}/details/total-influencers-count`,
    analyzedIfluencersCount: `${ENTITIES_URI_PREFIX}/details/analyzed-influencers-count`,
    unAnalyzedIfluencersCount: `${ENTITIES_URI_PREFIX}/details/unanalyzed-influencers-count`,
    totalIfluencersTweets: `${ENTITIES_URI_PREFIX}/details/total-tweets`,
    totalIfluencersGroups: `${ENTITIES_URI_PREFIX}/groups/total-groups`,
    totalIfluencersCategories: `${ENTITIES_URI_PREFIX}/categories/total-categories`,
    topFiveTrendingInfluencers: `${ENTITIES_URI_PREFIX}/details/bar-latest-five-influencer`,
    influencersGroup: `${ENTITIES_URI_PREFIX}/groups/per-group-chart`,
    influencersCategory: `${ENTITIES_URI_PREFIX}/categories/inf-category-chart`,
    influencersPlatform: `${ENTITIES_URI_PREFIX}/details/platform`,
    influencersAgeGroup: `${ENTITIES_URI_PREFIX}/details/age-group`,
    influencersGender: `${ENTITIES_URI_PREFIX}/details/gender`,
    topInfluencers: `${ENTITIES_URI_PREFIX}/details/dashboard-top-influencers`,
    influencersMap: GENERATE_URI(`${ENTITIES_URI_PREFIX}/details/map`),
    dashboardCatSubCat: `${ENTITIES_URI_PREFIX}/categories/inf-count-per-subcategory`,
    loadCalendarData: `${ENTITIES_URI_PREFIX}/details/youtube/month-calender`,
    entityAuthorArticleCount: `${ENTITIES_URI_PREFIX}/authors/articles/count`,
    entityAuthorSourcesCount: `${ENTITIES_URI_PREFIX}/authors/sources/count`,
    entityAuthorArticleAverage: `${ENTITIES_URI_PREFIX}/authors/average-articles`,
    entityAuthorArticleChart: `${ENTITIES_URI_PREFIX}/authors/article-chart`,
    entityAuthorSources: `${ENTITIES_URI_PREFIX}/authors/sources`,
    entityAuthorTags: `${ENTITIES_URI_PREFIX}/authors/tags`,
    entityAuthorCalander: `${ENTITIES_URI_PREFIX}/authors/calendar`,
    logs: `${ENTITIES_URI_PREFIX}/details`,
    convertInfluencer: `${ENTITIES_URI_PREFIX}/details/convert`,
    infInfoOptions: `${ENTITIES_URI_PREFIX}/information/sections`,
    entityRelationOptions: `${ENTITIES_URI_PREFIX}/details/relations`,
    //related influencer
    allRelatedInfluencers: `${ENTITIES_URI_PREFIX}/details/related-influencers/`,
    coworkersRelatedInfluencers: `${ENTITIES_URI_PREFIX}/details/related-influencers/coworkers`,
    mentionsRelatedInfluencers: `${ENTITIES_URI_PREFIX}/details/related-influencers/mentions`,
    mapGraph: `${ENTITIES_URI_PREFIX}/details/related-influencers/map`,
    mapGraphTree: `${ENTITIES_URI_PREFIX}/details/related-influencers/map/tree`,
    //related entity
    allRelatedEntities: `${ENTITIES_URI_PREFIX}/details/related-entities/`,
    coworkersRelatedEntities: `${ENTITIES_URI_PREFIX}/details/related-entities/coworkers`,
    mentionsRelatedEntities: `${ENTITIES_URI_PREFIX}/details/related-entities/mentions`,
    organizationAutoComplete: `${ENTITIES_URI_PREFIX}/details/organization`,
    regrabGroup: `${ENTITIES_URI_PREFIX}/groups/regrab`,
    getReportEntitiesCount: `${ENTITIES_URI_PREFIX}/details/detailed-reports/count`,
  };
};
